import { Outlet } from "react-router-dom";

const RouterD = () => {
  return (
    <>
      <Outlet />
    </>
  );
};
export default RouterD;
